<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-layout column>
        <v-text-field label="申请人" v-model="form.name" disabled></v-text-field>
      </v-layout>
      <v-layout column>
        <v-card v-for="a in form.apply" class="ma-3 pl-3">
          <v-layout column>
            <v-flex>
              <v-text-field v-model="a.date" lable="申请补卡日期" disabled></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="a.msg" lable="申请补卡信息" disabled></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field v-model="a.type" lable="申请补卡类型" disabled></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex pa-3>
          <v-textarea label="申请理由" v-model="form.comment" rows="1" auto-grow disabled></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout column v-if="form.urls.length!==0">
        <p>健康证明</p>
        <v-flex v-for="(u,index) in form.urls">
          <v-layout>
            <v-btn flat color="primary" @click="download(u)">点击查看</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout class="pl-3 ml-3" column>
        <p v-if="formData.firstAuditStatus==='1'" style="color:green">二级单位审核状态：已通过</p>
        <v-layout v-else-if="formData.firstAuditStatus==='2'">
          <p  style="color:red">二级单位审核状态：已拒绝。</p>
          <p  style="color:red">附言:{{formData.firstAuditComment}}</p>
        </v-layout>
        <p v-else >二级单位审核状态：待审核</p>
        <p>二级单位审核人：{{form.firstReview}}</p>
      </v-layout>
      <v-layout class="pl-3 ml-3" column v-if="formData.reqType==='1'">
        <p v-if="formData.medicineAuditStatus==='1'" style="color:green">校医院审核状态：已通过</p>
        <v-layout v-else-if="formData.medicineAuditStatus==='2'">
          <p  style="color:red">校医院审核状态：已拒绝。</p>
          <p  style="color:red">附言:{{formData.medicineAuditComment}}</p>
        </v-layout>
        <p v-else-if="formData.firstAuditStatus==='2'||formData.firstAuditStatus==='0'">校医院审核状态：N/A</p>
        <p v-else>校医院审核状态：待审核</p>
        <p>校医院审核人：{{form.medicineReview}}</p>
      </v-layout>
      <v-layout class="pl-3 ml-3" column>
        <p v-if="formData.secondAuditStatus==='1'" style="color:green">人事处审核状态：已通过</p>
        <v-layout v-else-if="formData.secondAuditStatus==='2'">
          <p  style="color:red">人事处审核状态：已拒绝。</p>
          <p  style="color:red">附言:{{formData.secondAuditComment}}</p>
        </v-layout>
        <p v-else-if="formData.firstAuditStatus==='2'||formData.firstAuditStatus==='0'">人事处审核状态：N/A</p>
        <p v-else>人事处审核状态：待审核</p>
        <p>人事处审核人：{{form.secondReview}}</p>
      </v-layout>
      <v-layout justify-center v-if="status==='review'">
        <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="review($route.query.type,'1')">通过</v-btn>
        <v-btn class="error" :loading="loading" :disabled="disabledFlag" @click="refuseConfirm = true">拒绝</v-btn>
      </v-layout>
    </v-card>
    <v-dialog v-model="refuseConfirm" width="500">
      <v-layout column>
        <v-card class="pa-3">
          <v-form ref="form">
            <v-textarea v-model="form.reason" label="拒绝原因" :rules="[$rules.requiredS()]" rows="1" auto-grow></v-textarea>
          </v-form>
          <v-layout justify-center>
            <v-btn class="primary" :loading="loading" :disabled="disabledFlag" @click="review($route.query.type,'2')">确定</v-btn>
            <v-btn class="error" :loading="loading" :disabled="disabledFlag" @click="refuseConfirm = false">取消</v-btn>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
  function transType(v) {
    switch (v+'') {
      case "0":return "普通类型"
      case "1":return "指标异常"
    }
  }
    export default {
        name: "applyDetail",
        props:{
          formData:{
            type:Object,
            default:function () {
              return {}
            }
          }
        },
        data(){
          return {
            loading:false,
            disabledFlag:false,
            status:'readonly',
            refuseConfirm:false,
            isWeiXinFlag:false,
            form : {
              firstReview:"",
              secondReview:"",
              medicineReview:"",
              name:'',
              comment:'',
              typeSelect:[
                {value:'1',label:'身体数据异常'},
                {value:'0',label:'普通异常'}
              ],
              apply:[],
              message:'身体数据异常',
              urls:[],
              reason:''
            }
          }
        },
        async created(){
          this.isWeiXinFlag = this.is_weixin()
          await this.dealFormData()
        },
        methods:{
          async getUserInfo(code){
            if(code == null){
              return 'N/A'
            }
            let p = await this.$store.dispatch('login/getThemSelfInfo',code)
            console.log(p)
            return p.name
          },
          is_weixin() {
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
              //console.log('微信浏览器');
              return true
            } else {
              //console.log("不是微信浏览器");
              return false
            }
          },
          async dealFormData(){
            this.form.urls = JSON.parse(this.formData.files)
            this.form.name = this.formData.name
            this.form.comment = this.formData.reqComment
            let extend = JSON.parse(this.formData.extend)
            this.status = this.$route.query.status
            extend.forEach((a)=>{
              this.form.apply.push({
                date:a.date,
                msg:a.msg,
                type:transType(a.type)
              })
            })
            this.form.firstReview = await this.getUserInfo(this.formData.firstAuditor)
            this.form.secondReview = await this.getUserInfo(this.formData.secondAuditor)
            this.form.medicineReview = await this.getUserInfo(this.formData.medicineAuditor)
            this.dealStatus()
            return
          },
          dealStatus(){
            if(this.$route.query.type==='1'){
              if(this.formData.firstAuditStatus!=='0'){
                this.status = 'readonly'
              }
            }
            if(this.$route.query.type==='2'){
              if(this.formData.medicineAuditStatus!=='0'){
                this.status = 'readonly'
              }
            }
            if(this.$route.query.type==='3'){
              if(this.formData.secondAuditStatus!=='0'){
                this.status = 'readonly'
              }
            }
          },
          download(url){
            if(this.isWeiXinFlag){
              window.location.href = 'https://smaco2.uestc.edu.cn/passObjectApi'+url
              return
            }
            let isSupportDownload = 'download' in window.document.createElement('a')
            //console.log('get url', url, isSupportDownload)
            let el = window.document.createElement('a')
            el.href = 'https://smaco2.uestc.edu.cn/passObjectApi'+url
            el.target = '_blank'
            el.download = '健康证明'
            el.style.display = 'none'
            window.document.body.appendChild(el)
            el.click()
            window.document.body.removeChild(el)
          },
          async review(type,result){
            if(result==='2'){
              if(!this.$refs.form.validate()){
                this.$L.alert('error',{message:'请填写拒绝理由'})
                return
              }
            }
            let params = {
              "id":this.formData.id,
              "status":result,
              "comment":this.form.reason
            }
            try {
              this.loading = true
              let res = await this.$store.dispatch('school/reviewExtraSign',{params:params,type:type})
              if(res.data.status === 1){
                this.disabledFlag = true
                this.refuseConfirm = false
                this.$L.alert('success',{message:'审核成功'})
              }else{
                this.$L.alert('error',{message:'审核失败，原因是:'+res.data.msg})
              }
            }catch (e) {

            }finally {
              this.loading = false
            }
          }
        }
    }
</script>

<style scoped>

</style>
